import { render } from "./EventDetails.vue?vue&type=template&id=11e83d6f&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=11e83d6f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11e83d6f"

export default script